import React from 'react';
import styled from 'styled-components';


const CwCredits = styled.div<{
  color: string,
}>`
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
`;

const Link = styled.a<{
  color: string,
  hoverColor: string,
  transitionSettings: string,
}>`
  display: flex;
  align-items: center;
  color: ${({ color }) => color};
  text-decoration: none;
  transition: color ${({ transitionSettings }) => transitionSettings};
  
  &:hover{
    color: ${({ hoverColor }) => hoverColor};
    text-decoration: none !important;
    
    .wombatLogoBodyColor{
      fill: ${({ hoverColor }) => hoverColor};
    }
  }
`;

const StyledPath = styled.path<{ fillColor: string }>`
  fill: ${({ fillColor }) => fillColor};
`;

const CwCreditsLogo = styled.svg<{
  transitionSettings: string,
}>`
  width: 1.5rem;
  height: 1.5rem;
  transform: translateY(-0.1rem);
  margin-right: 0.1rem;
  margin-left: 0.2rem;
  
  ${StyledPath} {
    transition: fill ${({ transitionSettings }) => transitionSettings};
  }
`;

const Text = styled.span`
  margin-right: 0.2rem;

`;

interface IProp {
  fontSize?: string,
  primaryColor?: string,
  secondaryColor?: string,
  primaryColorOnHover?: string,
  transitionSettings?: string,
  className?: string,
}

/**
 *  Comonwombat Logo
 */
const CommonWombatCredits = ({
  primaryColor = '#000',
  secondaryColor = '#fff',
  primaryColorOnHover = '#4196b4',
  transitionSettings = '160ms ease-in-out',
  fontSize = '0.94rem',
  className,
}: IProp) => (
  <CwCredits
    color={primaryColor}
    className={className}
  >
    <span style={{ fontSize }}>Wykonanie:</span>
    <Link
      href="https://commonwombat.pl"
      target="_blank"
      rel="nofollow noopener noreferrer"
      color={primaryColor}
      hoverColor={primaryColorOnHover}
      transitionSettings={transitionSettings}
    >
      <CwCreditsLogo
        transitionSettings={transitionSettings}
        id="cw-credits-logo"
        version="1.2"
        viewBox="0 0 595.28 595.28"
        width="1em"
        height="1em"
      >
        <StyledPath
          fillColor={secondaryColor}
          className="wombatLogoEyesAndNoseColor"
          d="M486.475 116.088l-381.939-.418-86.977 279.702 275.307 197.431 6.093-.509 278.762-202.455z"
        />
        <StyledPath
          fillColor={primaryColor}
          className="wombatLogoBodyColor"
          d="M112.56 463.5l45.942-45.525.152.151.012-.012c6.843 5.767 15.669 9.255 25.319 9.255 21.721 0 39.329-17.608 39.329-39.329s-17.608-39.329-39.329-39.329-39.329 17.608-39.329 39.329c0 9.252 3.214 17.742 8.561 24.459l.507.504-46.709 46.52 5.545 3.977zM478.978 463.622l-45.942-45.525-.152.151-.012-.012c-6.843 5.767-15.669 9.255-25.319 9.255-21.721 0-39.329-17.608-39.329-39.329s17.608-39.329 39.329-39.329 39.329 17.608 39.329 39.329c0 9.252-3.214 17.742-8.561 24.459l-.507.504 46.709 46.52-5.545 3.977z"
        />
        <StyledPath
          fillColor={primaryColor}
          className="wombatLogoBodyColor"
          d="M487.419 115.181l24.105-70.137-61.661-43.76-.941.684-.002 112.248-306.736-.468.002-112.076-.948-.673-60.525 44.045 22.857 69.716-87.412 281.1 85.104 61.03 43.772-43.255c-4.044-6.772-6.961-16.412-6.961-24.874 0-25 20.267-45.267 45.267-45.267s45.267 20.266 45.267 45.267c0 25-20.267 45.267-45.267 45.267-8.772 0-18.318-3.576-25.246-7.902l-42.021 41.385 176.77 126.767v-66.767l-62.483-44.076 25.773-74.991H334.9l24.882 74.691-60.815 44.254v66.376l175.382-127.374-41.052-40.43c-6.928 4.327-16.474 7.902-25.246 7.902-25 0-45.267-20.267-45.267-45.267 0-25 20.267-45.267 45.267-45.267 25 0 45.267 20.267 45.267 45.267 0 8.461-2.917 18.102-6.961 24.874l42.725 42.221 90.04-65.393-91.703-275.117z"
        />
      </CwCreditsLogo>
      <Text style={{ fontSize }}>COMMON&nbsp;WOMBAT</Text>
    </Link>
  </CwCredits>
);


export default CommonWombatCredits;
